// Small, serializable UI preferences. Anything large (handles, parser state,
// aggregates) belongs in IndexedDB, never here.

const SETTINGS_KEY = 'rio-dashboard-combat-logs'

const DEFAULTS = {
    directoryName: '',
    monitorEnabled: true,
    selectedFileId: '',
    selectedSegmentKey: 'log',
    selectedPlayerGuid: '',
    activeTab: 'overview',
    sortKey: 'lastModified',
    sortDirection: 'desc',
    autoAnalyzeNewest: true,
    showNonGroupPlayers: false,
    onlyWowLogs: true,
    deathWindowSeconds: 10,
    linkedCharacterId: '',
    // Megabytes of cached reports to keep before the least recently used log is
    // evicted. Reports can always be rebuilt from the log itself.
    reportCacheMb: 64,
}

export function readSettings() {
    try {
        const raw = localStorage.getItem(SETTINGS_KEY)
        if (!raw) return { ...DEFAULTS }
        const parsed = JSON.parse(raw)
        return { ...DEFAULTS, ...(parsed && typeof parsed === 'object' ? parsed : {}) }
    } catch (error) {
        return { ...DEFAULTS }
    }
}

export function writeSettings(settings) {
    try {
        const allowed = {}
        Object.keys(DEFAULTS).forEach((key) => {
            allowed[key] = settings[key] === undefined ? DEFAULTS[key] : settings[key]
        })
        localStorage.setItem(SETTINGS_KEY, JSON.stringify(allowed))
    } catch (error) {
        // Settings are a convenience; private mode or a full quota must not break the view.
        console.warn('Unable to persist combat log settings', error)
    }
}

export function clearSettings() {
    try {
        localStorage.removeItem(SETTINGS_KEY)
    } catch (error) {
        console.warn('Unable to clear combat log settings', error)
    }
}

export { DEFAULTS as COMBAT_LOG_SETTINGS_DEFAULTS }
